// All of this shamelessly ripped from multi-download npm package, with one tweak

function fallback(urls) {
  let i = 0;

  (function createIframe() {
    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    frame.src = urls[i++];

    document.documentElement.appendChild(frame);

    // the download init has to be sequential otherwise IE only use the first
    const interval = setInterval(function() {
      if (
        frame.contentWindow.document.readyState === 'complete' ||
        frame.contentWindow.document.readyState === 'interactive'
      ) {
        clearInterval(interval);

        // Safari needs a timeout
        setTimeout(function() {
          frame.parentNode.removeChild(frame);
        }, 1000);

        if (i < urls.length) {
          createIframe();
        }
      }
    }, 100);
  })();
}

function download(url) {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  // firefox doesn't support `a.click()`...
  a.dispatchEvent(new MouseEvent('click'));
}

export function multiDownload(urls) {
  if (!urls) {
    throw new Error('`urls` required');
  }

  if (typeof document.createElement('a').download === 'undefined') {
    return fallback(urls);
  }

  let delay = 0;

  // TWEAK: add a delay between each download invocation. For some reason Chrome prefers this
  urls.forEach(function(url) {
    setTimeout(download.bind(null, url), 300 * ++delay);
  });
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/attachment/multidownload.js